import { Component, OnInit, OnDestroy } from '@angular/core';
import { faEdit, faRefresh, faBuilding, faUser, faPhone, faEnvelope, faLocationDot, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { Subject } from "rxjs";
import { UserCache } from "../services/user.cache";
import { UserManager } from "../services/user.manager";

/**
 * This component provides an overview of information for the logged-in user.
 */
@Component({
	selector: 'user-overview',
	templateUrl: './user-overview.component.html',
	styleUrl: './user-overview.component.scss'
})
export class UserOverviewComponent implements OnInit, OnDestroy {
	/**
	 * A subject that can be used to automatically end subscriptions when the component is destroyed.
	 * @private
	 */
	private readonly _destroying$ = new Subject<void>();

	// Icon definitions.
	public faEdit = faEdit;
	public faRefresh = faRefresh;
	public faBuilding = faBuilding;
	public faUser = faUser;
	public faPhone = faPhone;
	public faEmail = faEnvelope;
	public faAddress = faLocationDot;
	public faCircleInfo = faCircleInfo;
	
	public rfUpdateTooltip : string = "To update this information, please contact our support team at [phone number]. Our representatives are available [business hours] to assist you. Thank you!";
	public rfUpdateTooltipDelay : number = 1000;


	public get showRepairFacility(): boolean {
		return this.userManager.updatingRepairFacilities || this.userCache.selectedRepairFacility != undefined;
	}

	public get showContact(): boolean {
		return this.userManager.updatingContacts || this.userCache.selectedContact != undefined;
	}

	/**
	 * @constructor
	 * @param userManager The {@link UserManager} to use for updates.
	 * @param userCache The {@link UserCache} to use for user data.
	 */
	constructor(public userManager: UserManager,
				public userCache: UserCache) {
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
		this._destroying$.next(undefined);
		this._destroying$.complete();
	}
}
